import actions from './store/actions';
import createRouterMiddleware from '@synergycms_core/middlewares/actionRouter';
import initializeStore, { getParamsFromWindow } from './start';
import { fromJS, Map, List } from 'immutable';
import {
  recoverReservation,
  recoverBookingBlocksFromAvailMail,
  generateBlockFromParams
} from './store/customer/reservation/reservationUtils';
import { pipe } from 'ramda';
import storage from '@synergycms_core/utils/storage';
import moment from 'moment';
import { getCompanyAvailIdentifier } from './store/customer/corporateActions';
import { getStoredUserSafe, shouldRestoreUser } from './utils';
import { getLoyaltyTier } from './store/customer/loyaltyUtils';
import { contextualizeAppConfig } from '@synergycms_core/store/app/utils';

const {
  currencies: currenciesActions,
  currencyCountry: currencyCountryActions,
  currentCurrency: currentCurrencyActions,
  step: stepActions,
  ipCountry: ipCountryActions,
  params: paramActions,
  currentHotels: currentHotelsActions,
  currentHotel: currentHotelAction,
  filters: filtersActions,
  orderBy: orderByActions,
  roomPreferences: roomPreferencesActions,
  cardMask: cardMaskActions,
  hasCvv: hasCvvActions,
  reservation: reservationActions,
  loyalty: loyaltyActions,
  corporate: corporateActions
} = actions.customer;

const hotelsActions = actions.hotels;
const availActions = actions.avail;
const availServicesActions = actions.availServices;
const availCacheActions = actions.availCache;

export const RouteResolver = (arrayHash, queryObj) => {
  return (dispatch, getState) => {
    let [baseRoute, currency = false, reservationTrackingId = queryObj.get('tracking_id') || false] = arrayHash;
    let availInitializePromise = Promise.resolve();

    queryObj = pipe(fromJS, getParamsFromWindow)(queryObj);
    if (validParams(queryObj)) {
      // CANVI URL
      if (!getState().getIn(['customer', 'step', 'loaded'])) {
        //inicialització del store
        const initializeValues = initializeStore(baseRoute, arrayHash, queryObj, dispatch);

        // inicialització del stepmanager
        dispatch(stepActions.initialize(initializeValues));

      } else {
        if (getState().getIn(['customer', 'step', 'current_step', 'isAlter'], false)) {
          dispatch(
            stepActions.changeAlter(baseRoute || getState().getIn(['customer', 'step', 'alter_list', 0, 'code']))
          );
        } else {
          dispatch(stepActions.change(baseRoute || getState().getIn(['customer', 'step', 'list', 0, 'code'])));
        }
      }

      let currentStep = getCurrentStep(getState);

      // GLOSARIO.md - FCL-001
      if (queryObj.get('selection_avail')) {
        sessionStorage.removeItem('last_reservation_request');
        dispatch(actions.customer.selectionAvail.set(queryObj.get('selection_avail')));
      }
      // GLOSARIO.md - FCL-001
      if (queryObj.get('force_step')) {
        dispatch(actions.customer.forcedStep.set(queryObj.get('force_step')));
        if (queryObj.get('force_step') === '2') {
          dispatch(actions.customer.step.jumpSteps.set(['monoHotelAvail']));
        } else if (queryObj.get('force_step') === '3') {
          dispatch(actions.customer.step.jumpSteps.set(['monoHotelAvail', 'serviceHotelAvail']));
        }
        queryObj = queryObj.set('force_step', null);
      }

      const loginConfig = window.frontLoader?.['cms-login']?.config || false;
      let loggedUserPromise = Promise.resolve();

      if (loginConfig) {
        const { entity } = loginConfig;

        let loginContext = {
          key: '',
          value: ''
        };

        if (loginConfig.hotel_id) {
          loginContext.key = 'hotel_id';
          loginContext.value = loginConfig.hotel_id;
        } else if (loginConfig.group_id) {
          loginContext.key = 'group';
          loginContext.value = getState().get('group', '');
        }

        if (window.LoginUser?.company_id) {
          dispatch(corporateActions.get(window.LoginUser));
        } else {
          let remember = 0;
          const loginUserInfo = storage.get('login_user') || ((remember = 1), storage.getLocal('login_user')) || null;

          if (loginUserInfo) {
            if(!loginUserInfo?.login_id) { //controlar si no es company TMP!
              loggedUserPromise = Promise.resolve();
            } else {
              const { user_id = '', token = '' } = loginUserInfo;
              const authToken = btoa(`${user_id}:${token}`);
              if (entity === 'company') {
                loggedUserPromise = dispatch(
                  corporateActions.getUserAsync(loginContext, authToken, remember, loginUserInfo)
                );
              } else if (entity === 'loyalty') {
                loggedUserPromise = dispatch(
                  loyaltyActions.getUserAsync(loginContext, authToken, remember, loginUserInfo)
                );
              }
            }
          }
        }
      }

      //validem q el tipo de parametre d'hotel estigui correcte respecte l'step, en cas contrari redirigim la ruta
      if (queryObj.get('hotelCodes') && currentStep.get('type') !== 'multi') {
        dispatch(stepActions.change('multiHotelAvail'));
      }
      if (queryObj.get('hotelCode') && currentStep.get('type') !== 'mono') {
        dispatch(stepActions.change('monoHotelAvail'));
      }

      currentStep = getCurrentStep(getState);

      let windowConfig = {};
      if (window.frontLoader && window.frontLoader['cms-avail']) {
        windowConfig = {
          ...(window.frontLoader.hotel_id && { hotel_id: window.frontLoader.hotel_id }),
          ...(window.frontLoader.hotels_info && { hotels_info: window.frontLoader.hotels_info })
        };
      } else if (window.engine_sygy_data) {
        windowConfig = window.engine_sygy_data;
      }

      const hotId = windowConfig.hotel_id || window.id_hotel;
      const hotelsInfo = windowConfig.hotels_info || window.hotels_info;
      let appPromise = Promise.resolve();
      if (!hotelsInfo && hotId) {
        appPromise = dispatch(actions.app.config.getHotelAsync('cms-avail;cms-engine', hotId));
      } else {
        appPromise = dispatch(actions.app.config.getAsync('cms-avail;cms-engine'));
      }

      const paramsPromises = [dispatch(currenciesActions.getAsync()), appPromise, loggedUserPromise];

      const paramsPromise = Promise.all(paramsPromises).then(() => {
        let corporateObject = getCompanyAvailIdentifier(getState().getIn(['customer', 'corporate'], Map()));

        if (corporateObject) {
          queryObj = queryObj.set('company_id', corporateObject.value);
        } else {
          if (window.LoginUser?.company_id) {
            dispatch(corporateActions.get(window.LoginUser));
            corporateObject = getCompanyAvailIdentifier(getState().getIn(['customer', 'corporate'], Map()));
            queryObj = queryObj.set('company_id', corporateObject.value);
          } else {
            queryObj = queryObj.set('company_id', null);
          }
        }

        dispatch(currentCurrencyActions.set(currency));
        return dispatch(currencyCountryActions.getAsync()).then(() => {
          const loyalty = getLoyaltyTier(getState()) || getState().getIn(['customer', 'loyalty', 'user'], null);
          queryObj = queryObj.set('loyalty', loyalty);
          dispatch(paramActions.createFromUrl(queryObj, currentStep));
          //validem q els hotels existeixin
          const urlParams = getState().getIn(['customer', 'params', 'params']);
          if (!urlParams.get('hotels').size && !urlParams.get('hotelId')) {
            dispatch(actions.router.error());
          }
        });
      });

      // primero, extraemos los dos posibles orígenes de "locale"
      const urlPOS = queryObj.get('POS', null);
      const urlTrvLocale = queryObj.get('trv_locale', null);

      // si existe POS en la URL, lo usamos; si no, miramos trv_locale
      const locale = urlPOS || urlTrvLocale;

      if (locale !== null) {
        storage.setLocal('POS', locale);
      }
      switch (currentStep.get('code')) {
        case 'multiHotelAvail':
          availInitializePromise = paramsPromise.then(() => {
            dispatch(currentHotelAction.clear());
            dispatch(currentHotelsActions.set());

            // Comprobamos que las fechas de disponibilidad son correctas si tiene la config de disable_redir_invalid_date
            const checkinIsValid = verifyCheckin(dispatch, getState);
            if (!checkinIsValid) {
              changeToAlterStep(dispatch, getState, 'noAvail', 'multi');
            }

            return Promise.all([
              dispatch(hotelsActions.getAsync()),
              dispatch(loyaltyActions.getDescriptiveAsync(getState().get('group'))).then(() => {
                if (shouldRestoreUser(getState)) {
                  const user = getStoredUserSafe();
                  if (user) dispatch(loyaltyActions.get(user));
                }
                return dispatch(availActions.getAvailAsync(getState().get('group'), [], false));
              })
            ])
              .then(() => {
                // Init orderBy and filters
                dispatch(currentCurrencyActions.set(currency));
                dispatch(
                  orderByActions.set(getState().get('group', false) === 'eurostarshotels' ? 'proximity' : 'price')
                );
                dispatch(filtersActions.get());

                return;
              })
              .then(() => {
                dispatch(availServicesActions.getAsync());
              });
          });
          break;
        case 'cancelation':
        case 'newCof':
          return paramsPromise.then(() => {
            const pin = getState().getIn(['customer', 'params', 'params', 'pin'], false);

            if (reservationTrackingId && pin) {
              dispatch(currentHotelAction.set());
              let reservationPromise =
                queryObj.get('from_tms') === 'true'
                  ? dispatch(reservationActions.getTmsAsync(reservationTrackingId, pin))
                  : dispatch(reservationActions.getAsync(reservationTrackingId, pin));

              return Promise.props({
                reservation: reservationPromise,
                hotel: dispatch(hotelsActions.getAsync())
              }).then((props) => {
                if (currentStep.get('code') === 'newCof') {
                  const reservation = props.reservation;
                  return Promise.props({
                    cardMask: dispatch(cardMaskActions.getAsync(reservation)),
                    hasCvv: dispatch(hasCvvActions.getAsync(reservation))
                  }).finally(() => {
                    dispatch(actions.router.update(true));
                    return true;
                  });
                } else {
                  dispatch(actions.router.update(true));
                  return true;
                }
              });
            } else {
              dispatch(actions.router.update(true));
            }
          });
        case 'noAvail':
          return paramsPromise.then(() => {
            if (currentStep.get('type') === 'multi') {
              dispatch(currentHotelAction.clear());
              dispatch(currentHotelsActions.set());
            } else {
              dispatch(currentHotelAction.set());
            }

            let hotelPromise = dispatch(hotelsActions.getAsync());

            // Si entramos por este step directamente, comprobamos que las fechas sean posteriores o iguales al día actual
            // y redirigimos al step de disponibilidad si es correcto
            const params = getState().getIn(['customer', 'params']);
            const urlParams = params.get('url_params', Map());
            if (!moment(urlParams.get('start')).isBefore(moment().startOf('day'))) {
              const step = params.getIn(['params', 'hotels']).size > 1 ? 'multiHotelAvail' : 'monoHotelAvail';
              dispatch(actions.customer.step.change(step));
              dispatch(actions.router.update(true));
              return true;
            }

            const promises = [dispatch(hotelsActions.get())];

            if (currentStep.get('type') === 'mono') {
              promises.push(
                dispatch(loyaltyActions.loyaltyAsync()).then(() => {
                  if (shouldRestoreUser(getState)) {
                    const user = getStoredUserSafe();
                    if (user) dispatch(loyaltyActions.get(user));
                  }
                  return Promise.all([
                    dispatch(availActions.getAvailAsync()),
                    hotelPromise.then(() => dispatch(availActions.getFlexibleAsync()))
                  ]);
                })
              );
            }
            return Promise.all([...promises, dispatch(ipCountryActions.getAsync())]).then(() => {
              dispatch(currentCurrencyActions.set(currency));
              if (currentStep.get('type') === 'mono') {
                dispatch(availActions.getAvailParsed());
              }
              dispatch(availActions.setRelatedAvail());
              dispatch(roomPreferencesActions.initialize());
              return dispatch(actions.router.update(true));
            });
          });
        case 'monoHotelAvail':
        case 'serviceHotelAvail':
        case 'customerForm':
        case 'confirmation':
        default:
          availInitializePromise = paramsPromise.then(() => {
            dispatch(currentHotelAction.set());
            let hotelPromise = dispatch(hotelsActions.getAsync());
            const promises = [hotelPromise.then(() => dispatch(ipCountryActions.getAsync()))];

            // Comprobamos que las fechas de disponibilidad son correctas si tiene la config de disable_redir_invalid_date
            const checkinIsValid = verifyCheckin(dispatch, getState);
            if (!checkinIsValid) {
              changeToAlterStep(dispatch, getState, 'noAvail', 'mono');
            }

            promises.push(
              dispatch(availServicesActions.getAsync()),
              dispatch(loyaltyActions.loyaltyAsync()).then(() => {
                if (shouldRestoreUser(getState)) {
                  const user = getStoredUserSafe();
                  if (user) dispatch(loyaltyActions.get(user));
                }
                if (currentStep.get('code') === 'customerForm') {
                  const availTypeSelected = sessionStorage.getItem('avail_type_selected');
                  if (availTypeSelected) {
                    dispatch(actions.customer.availTypeSelected.set(availTypeSelected));
                  }
                }
                return Promise.all([
                  dispatch(availActions.getAvailAsync()),
                  hotelPromise.then(() => dispatch(availActions.getFlexibleAsync()))
                ]);
              })
            );

            const stepType = getStepType(getState);

            if (currentStep.get('code') === 'monoHotelAvail' && stepType !== 'WI') {
              let availCacheParams = getState().getIn(['customer', 'params', 'avail_cache_params'], Map());
              const availCacheStringParams = getState().getIn(['customer', 'params', 'avail_cache_query_params']);
              const cities = getState().getIn(['hotels', 'hotels_info', 'cities'], List());
              const hotelsDescriptives = getState().getIn(['hotels']);
              const hotelId = getState().getIn(['customer', 'current_hotel']);
              const hotel = hotelsDescriptives
                .getIn(['hotels_info', 'hotels'])
                .find((hotel) => hotel.get('id') === hotelId);
              const hotelCity = cities.find((city) => city.get('id') === hotel.get('city_id'));
              const urlParams = getState().getIn(['customer', 'params', 'url_params']);

              availCacheParams = availCacheParams.set('city_id', hotelCity.get('id'));
              availCacheParams = availCacheParams.set('hotelId', null);

              promises.push(
                dispatch(
                  availCacheActions.getAsync(moment(urlParams.get('start')), moment(urlParams.get('end')), {
                    params: availCacheParams,
                    stringParams: availCacheStringParams
                  })
                )
              );
            }

            return Promise.all(promises).then(() => {
              dispatch(currentCurrencyActions.set(currency));
              dispatch(availActions.getAvailParsed());
              dispatch(availActions.setRelatedAvail());
              dispatch(roomPreferencesActions.initialize());
              return true;
            });
          });
      }
      return availInitializePromise.then(() => {
        let recoveredReservationRequest = null;
        if (
          getState().getIn(['customer', 'selection_avail']) &&
          List.isList(getState().getIn(['customer', 'selection_avail']))
        ) {
          const blocks = generateBlockFromParams(getState());
          if (blocks && blocks.size && blocks.some((b) => b.get('price', false))) {
            dispatch(actions.customer.reservationRequest.initialize(blocks));
            recoveredReservationRequest = getState().getIn(['customer', 'reservation_request']);
          }
        } else if (queryObj.get('resRequest')) {
          recoveredReservationRequest = recoverBookingBlocksFromAvailMail(getState, queryObj);
        }

        return recoverReservation(dispatch, getState, reservationTrackingId, recoveredReservationRequest).then(
          (recoveredTrackingId) => {
            const currentStepCode = getCurrentStep(getState).get('code');

            if (
              !recoveredTrackingId &&
              (currentStepCode === 'customerForm' || currentStep.get('code') === 'confirmation') &&
              !getState().getIn(['customer', 'selection_avail'], false)
            ) {
              dispatch(stepActions.change('monoHotelAvail'));
            } else if (
              recoveredTrackingId &&
              currentStep.get('code') === 'confirmation' &&
              getState().getIn(['customer', 'reservation', 'status']) !== 'confirmed'
            ) {
              dispatch(stepActions.change('customerForm'));
            }

            if(currentStepCode === 'customerForm') {
              const reservation = getState().getIn(['customer', 'reservation']);
              const selectedAvailType = getState().getIn(['customer', 'avail_type_selected']);
              let requestDispo = false;

              // Validamos que el tipo de dispo seleccionado corresponde con el tipo de dispo de la reserva, en caso contrario, 
              // lo corregimos y volvemos a pedir dispo para evitar posibles errores en el proceso de reserva
              if(selectedAvailType === 'loyalty' && reservation.size && !reservation.get('loyalty', false)) { 
                dispatch(actions.customer.availTypeSelected.set("standard"));
                sessionStorage.setItem('avail_type_selected', 'standard');
                requestDispo = true;
              } else if(selectedAvailType === 'standard' && reservation.size && reservation.get('loyalty', false)) {
                dispatch(actions.customer.availTypeSelected.set("loyalty"));
                sessionStorage.setItem('avail_type_selected', 'loyalty');
                requestDispo = true;
              }

              // Si finalmente hemos tenido que corregir el availTypeSelected, pedimos de nuevo la dispo
              if(requestDispo) {
                return Promise.all([
                  dispatch(availActions.getAvailAsync()),
                  dispatch(availActions.getFlexibleAsync())
                ]).then(() => {
                  dispatch(availActions.getAvailParsed());
                  dispatch(availActions.setRelatedAvail());
                  dispatch(actions.router.update(true));
                  return true;
                });
              }
            }

            dispatch(actions.router.update(true));
            return true;
          }
        );
      });
    } else {
      dispatch(actions.router.error());
    }
  };
};

const getCurrentStep = (getState) => getState().getIn(['customer', 'step', 'current_step']);
const getStepType = (getState) => getState().getIn(['customer', 'web_type'], 'WI');

const validParams = (queryObj) => {
  let validParams = true;
  //Validem parametres necessaris
  if (!queryObj.get('hotelCodes') && !queryObj.get('hotelCode')) {
    validParams = false;
  }

  return validParams;
};

/**
 *
 * @param {*} dispatch
 * @param {*} getState
 * @returns boolean Indica si la fecha de inicio es pasada o no en función de la configuración disable_redir_invalid_date
 */
const verifyCheckin = (dispatch, getState) => {
  const store = getState();
  const hotelId = store.getIn(['customer', 'current_hotel'], null);
  const config = contextualizeAppConfig(store, hotelId);

  // Si la configuración disable_redir_invalid_date está activa, comprobamos que la fecha de inicio no sea anterior al día actual
  if (config.get('disable_redir_invalid_date', false)) {
    const params = getState().getIn(['customer', 'params']);
    const urlParams = params.get('url_params', Map());
    // Si la fecha de inicio es anterior al día actual, redirigimos al paso noAvail
    if (moment(urlParams.get('start')).isBefore(moment().startOf('day'))) {
      return false;
    }
  }
  return true;
};

/**
 *
 * @param {*} dispatch
 * @param {*} getState
 * @param {string} stepCode
 * @param {string} stepType
 *
 * El código en general necesita saber el tipo de step (mono/multi) para funcionar correctamente. Si queremos cambiar a un step alter (noAvail) y no sabemos el tipo, no podremos.
 * Por eso, para cambiar a un step alter, necesitamos que se le pase el tipo de step.
 *
 */
const changeToAlterStep = (dispatch, getState, stepCode, stepType = 'mono') => {
  dispatch(actions.customer.step.updateAlterStep(Map({ code: stepCode, type: stepType })));
  dispatch(actions.customer.step.changeAlter(stepCode));
};


export default createRouterMiddleware(RouteResolver, { fireInitial: true });
